<template>
  <v-row class="py-10 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" md="3" class="pa-0 ma-0">
        </v-col>
        <v-col cols="12" md="6" LOGO>
          <v-card class="text-center py-5 elevation-2 align-center">
            <img v-if="site.logo" :src="site.logo" height="70" alt="">
            <span v-if="!site.logo" class="headline">{{site.name}}</span>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" class="pa-0 ma-0">
        </v-col>
        <v-col cols="12" md="3" class="pa-0 ma-0">
        </v-col>
        <v-col cols="12" md="6" INVITATION>
          <v-card class="px-3" :loading="loading">
            <v-card-text v-if="invitation">
              <v-row class="pa-0" v-if="lead">
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2 font-weight-bold`">
                  مرحبا بك {{lead.name}}
                </v-col>
                <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  نشكرك على اتصالك بفرع ارامكو في {{lead.country_name.ar}} بخصوص الانضمام لبرنامج ارامكو الخاص ب{{lead.program_name.ar}}
                </v-col>
                <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  لقد تم تسجيل اتصالك من هاتف رقم 
                  <v-chip label color="primary" dark small class="mx-2">{{ lead.phone }}</v-chip>
                </v-col>
                <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  انت مدعو لحضور المقابلة الخاصة بك للأنضمام للبرنامج يوم
                  <v-chip label color="error" dark small class="mx-2">{{day}}</v-chip>
                  الساعة
                  <v-chip label color="error" dark small class="mx-2">{{interview.time}}</v-chip>
                </v-col>
                <v-col cols="12" style="font-size:16px;line-height:2;white-space: pre-line;white-space: break-spaces;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                </v-col>
                <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  للأستفسار يمكنك الاتصال بنا على رقم هاتف 
                  <div>{{interview.phones}}</div>
                </v-col>
                <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  عنوان المكتب حيث ستتم المقابلة
                  <div>{{interview.company_address}}</div>
                </v-col>
              </v-row>
                <v-divider></v-divider>
              <v-row class="pa-0" v-if="lead">
                <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  يرجى منك ادخال ايميلك هنا لنتمكن من التواصل معك عبر الايميل
                </v-col>
                <v-col cols="12" style="font-size:16px;line-height:2;direction:ltr;" :class="`enFont forceLTR pa-0 pt-2`">
                  <v-text-field
                    name="email"
                    filled
                    v-model.trim="email"
                    :class="`${arabic?'arFont':'enFont'}`"
                    :rules="[rules.email, rules.required]"
                    label="Email"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  <v-btn 
                    :loading="loading"
                    :disabled="!email || !testEmail()" 
                    :class="`${arabic?'arFont':'enFont'}`" 
                    block 
                    @click="saveEmail()"
                    color="primary">
                    تخزين الايميل
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text v-if="confirmation">
              <v-row class="pa-0" v-if="lead">
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2 font-weight-bold`">
                  مرحبا بك {{lead.name}}
                </v-col>
                <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  بناء على دراسة المعلومات المحدودة المقدمة من طرفك لنا فأنك مؤهل للأنضمام لبرنامج ارامكو الخاص ب{{lead.program_name.ar}}
                  من دولة
                  {{lead.country_name.ar}}
                </v-col>
                <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  <v-btn 
                    :class="`${arabic?'arFont':'enFont'}`" 
                    block 
                    large
                    :loading="loading"
                    @click="scrollDown()"
                    color="success">
                    اضافة معلوماتك للحصول على موعد
                  </v-btn>
                </v-col>
                <v-col cols="12" md="12" class="pa-0 ma-0">
                  <v-card outlined color="primary">
                    <v-card-text>
                      <v-row class="pa-0" >
                        <v-col cols="12" style="font-size:16px;line-height:2;font-weight:bold;" :class="`${arabic?'arFont':'enFont'} white--text py-0`">
                          مميزات برنامج {{lead.program_name.ar}}
                        </v-col>
                        <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} white--text py-0`">
                          <v-row class="pa-0" >
                            <v-col cols="12" 
                              v-for="(ad, aa) in seminars[0].advantages_array"
                              :key="'advantage-'+aa"
                              style="font-size:16px;line-height:2;" 
                              :class="`${arabic?'arFont':'enFont'} white--text py-0`">
                              <v-icon dark>check_circle_outline</v-icon>
                              {{ad}}
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  <div>لقد تم تسجيل المعلومات التالية في طلبك لدينا:</div>
                  <div>
                    الاسم
                    <v-chip label color="primary" dark small class="mx-2">{{ lead.name }}</v-chip>
                  </div>
                  <div>
                    رقم الهاتف
                    <v-chip label color="primary" dark small class="mx-2">{{ lead.phone }}</v-chip>
                  </div>
                  <div>
                    الايميل
                    <v-chip label color="primary" dark small class="mx-2">{{ lead.email }}</v-chip>
                  </div>
                  <div>
                    الدولة
                    <v-chip label color="primary" dark small class="mx-2">{{ lead.country_name.ar }}</v-chip>
                  </div>
                  <div>
                    البرنامج
                    <v-chip label color="primary" dark small class="mx-2">{{ lead.program_name.ar }}</v-chip>
                  </div>
                </v-col>
                <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  <v-card outlined>
                    <v-card-text>
                      <v-row class="py-0 align-center" v-if="!confirmDetails">
                        <v-col cols="12" style="font-size:16px;line-height:2;font-weight:bold;" :class="`${arabic?'arFont':'enFont'} px-5 py-2`">
                          <div>هل تتوفر لديك الشروط التالية للترشح لحضور مقابلة شخصية مع فريق ارامكو؟</div>
                          <div style="font-weight:normal;" class="error--text">(يرجى الاختيار نعم او لا)</div>
                        </v-col>
                        <v-col cols="12" :class="`${arabic?'arFont':'enFont'} py-0 px-5`" v-for="(cm, c) in seminars[0].conditions_array" :key="'cm-'+c">
                          <v-row class="pa-0 align-center">
                            <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'} py-2`" style="font-size:16px;">
                              {{cm}}
                            </v-col>
                            <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'} py-0`">
                              <v-btn-toggle
                                v-model="conditions_met[c]"
                                mandatory
                                tile
                                color="primary"
                                background-color="primary"
                                group
                                borderless
                                large
                              >
                                <v-btn x-large :loading="loading" @click="started_answer()" :disabled="confirmDetails" :value="true" :class="`${arabic?'arFont':'enFont'}`">
                                  <v-icon color="primary" size="18" left v-if="conditions_met[c]">radio_button_checked</v-icon>
                                  <v-icon color="primary" size="18" left v-else>radio_button_unchecked</v-icon>
                                  نعم
                                </v-btn>
                                <v-btn x-large :loading="loading" @click="started_answer()" :disabled="confirmDetails" :value="false" :class="`${arabic?'arFont':'enFont'}`">
                                  <v-icon color="primary" size="18" left v-if="!conditions_met[c]">radio_button_checked</v-icon>
                                  <v-icon color="primary" size="18" left v-else>radio_button_unchecked</v-icon>
                                  لا
                                </v-btn>
                              </v-btn-toggle>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" v-if="!confirmDetails" style="font-size:16px;line-height:2;font-weight:bold;" :class="`${arabic?'arFont':'enFont'} px-5 py-2 pt-4`">
                          <v-btn x-large :loading="loading" :class="`${arabic?'arFont':'enFont'}`" color="primary" block @click="updateScore()">تأكيد البيانات المدخلة</v-btn>
                        </v-col>
                      </v-row>
                      <v-row class="py-0 align-center" v-if="confirmDetails">
                        <v-col cols="12" v-if="confirmDetails" style="font-size:16px;line-height:2;font-weight:bold;" :class="`${arabic?'arFont':'enFont'} px-5 py-2`">
                          <v-btn :loading="loading" :class="`${arabic?'arFont':'enFont'}`" color="error" text block @click="changeDetails()">تعديل البيانات</v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`" v-if="confirmDetails && checkIfFit">
                  <v-card outlined>
                    <v-card-text>
                      <v-row class="align-center">
                        <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-2`">
                          <div style="font-weight:700;">انت مدعو لحضور سيمينار عبر الانترنت لبرنامج {{ lead.program_name.ar }}</div>
                          يرجى اختيار الموعد المناسب لك:
                          <v-row class="align-center">
                            <v-col cols="12" :class="`pa-2`">
                              <v-radio-group v-model="selectedSeminar" hide-details>
                                <v-col cols="12" :class="`pa-2`" v-for="(seminar, ss) in seminars" :key="'seminar-'+ss">
                                  <v-radio :value="seminar.id" hide-details>
                                    <template v-slot:label>
                                      <v-row class="pa-0 text-right">
                                        <v-col cols="12" :class="`pa-0`">
                                          يوم
                                          <v-chip label color="error" dark small class="mx-2">{{seminar.day_ar}}</v-chip>
                                          الموافق
                                          <v-chip label color="error" dark small class="mx-2">{{seminar.next_date}}</v-chip>
                                          الساعة
                                          <v-chip label color="error" dark small class="mx-2">{{seminar.local_time}}</v-chip>
                                          بتوقيت
                                          {{lead.country_name.ar}}
                                        </v-col>
                                        <v-col cols="12" :class="`py-2`" style="font-size:12px;">
                                          *الساعة {{seminar.time}} بتوقيت برلين
                                        </v-col>
                                      </v-row>
                                    </template>
                                  </v-radio>
                                </v-col>
                              </v-radio-group>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-2`">
                          يرجى منك تأكيد حضورك في الموعد المحدد
                        </v-col>
                        <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                          <v-btn 
                            :class="`${arabic?'arFont':'enFont'}`" 
                            block 
                            large
                            :loading="loading"
                            @click="confirmAppointment()"
                            color="primary">
                            اضغط لتأكيد الموعد
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`" v-if="confirmDetails && !checkIfFit">
                  <v-card outlined color="error">
                    <v-card-text>
                      <v-row class="align-center">
                        <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-2 white--text`">
                          نعتذر عن تحديد موعد لك، بسبب عدم توفر الشروط المطلوبة لديك لمزيد من المعلومات ان كان لديك اي استفسار يرجى التواصل معنا عبر ايميل <span style="color:blue;">care@aramccogermany.com</span> 
                        </v-col>
                        
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text v-if="confirmedAppointment">
              <v-row class="pa-0" v-if="lead && candidate">
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2 font-weight-bold`">
                  شكرا لك {{lead.name}} تم تأكيد موعد حضور السيمينار الخاص بك
                </v-col>
                <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  <v-card outlined>
                    <v-card-text>
                      <v-row class="align-center">
                        <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-2`">
                          موعد السيمنار
                        </v-col>
                        <v-col cols="12" :class="`pa-0`">
                          يوم
                          <v-chip label color="error" dark small class="mx-2">{{candidate.seminar.seminar.day_ar}}</v-chip>
                          الموافق
                          <v-chip label color="error" dark small class="mx-2">{{candidate.seminar.seminar.next_date}}</v-chip>
                          الساعة
                          <v-chip label color="error" dark small class="mx-2">{{candidate.seminar.seminar.local_time}}</v-chip>
                          بتوقيت
                          {{lead.country_name.ar}}
                        </v-col>
                        <v-col cols="12" :class="`py-2`" style="font-size:12px;">
                          *الساعة {{candidate.seminar.seminar.time}} بتوقيت برلين
                        </v-col>
                        <v-col cols="12" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`" v-if="candidate.seminar.join_url">
                          <v-btn color="success" large block @click="joinSeminarLink(candidate.seminar.join_url)">الدخول للسيمينار</v-btn>
                        </v-col>
                        <v-col cols="12" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`" v-if="candidate.seminar.recording_url">
                          <v-btn color="success" large block @click="joinSeminarLink(candidate.seminar.recording_url)">متابعة تسجيل السيمينار</v-btn>
                        </v-col>
                        <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-2`" v-if="!candidate.seminar.join_url && !candidate.seminar.recording_url">
                          <v-alert type="info" :value="true">
                            سيتم ارسال رابط Zoom للدخول للسيمينار قبل موعد السيمنار بساعة الى ايميلك، وكما سيظهر الرابط هنا ايضاً
                          </v-alert>
                        </v-col>
                        <v-col cols="12" style="font-size:16px;line-height:2;" :class="`${arabic?'arFont':'enFont'} pa-2`">
                          للأستفسار يمكنك التواصل معنا عبر ايميل 
                          <div style="font-weight:bold;color:blue;">care@aramccogermany.com</div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <iframe width="100%" height="315" :src="getLink()" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  <v-btn :class="`${arabic?'arFont':'enFont'}`" color="primary" block @click="openLink('https://events.aramccogermany.com/')">انجازات ارامكو</v-btn>
                </v-col>
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  <v-btn :class="`${arabic?'arFont':'enFont'}`" dark color="#FF0000" block @click="openLink('https://youtube.com/channel/UC4ymCRoAHZ3JBbjb2PE_GSw')">ارامكو يوتيوب</v-btn>
                </v-col>
                <v-col cols="12" style="font-size:18px;" :class="`${arabic?'arFont':'enFont'} pa-0 py-2`">
                  <v-btn :class="`${arabic?'arFont':'enFont'}`" dark color="#4267B2" block @click="openLink('https://www.facebook.com/aramccogermany')">ارامكو فيسبوك</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" class="pa-0 ma-0">
        </v-col>
        <v-col cols="12" md="3" class="pa-0 ma-0">
        </v-col>
        <v-col cols="12" md="6" LOGO>
          <v-card class="text-center py-5 elevation-2 align-center" color="primary" dark>
            <div style="font-size:12px;direction:ltr;">{{ footerdate }} &copy; {{company}}<sup>®</sup> <strong> | WEB</strong></div>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" class="pa-0 ma-0">
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import {firebase, db, auth} from '@/fb'
import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  data() {
    return {
      loading:false,
      dialog:false,
      lead:null,
      interview:null,
      footerdate: new Date().toISOString().substr(0, 4),
      company:'ARAMCCO IN GERMANY',
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      email:null,
      day:null,
      conditions:null,
      invitation:false,
      confirmation:false,
      conditions_met:[],
      confirmDetails:false,
      confirmedAppointment:false,
      date:null,
      start_answer:false,
      old:false,
      seminars:[],
      selectedSeminar:null,
      candidate:null,
    }
  },
  
  methods: {
    getLink() {
      let links = [
        'https://www.youtube.com/embed/LPefz6Q_hAo',
        'https://www.youtube.com/embed/9XA23N_gD-4',
        'https://www.youtube.com/embed/1hjwgC3B0ck',
        'https://www.youtube.com/embed/koUcqsDXIDc',
        'https://www.youtube.com/embed/3-gmf8lptYY',
      ]
      return links[getRandomInt(0, links.length)]
    },
    joinSeminarLink(url) {
      window.open(url, '_blank');
    },
    changeDetails(){
      this.confirmDetails = false
      this.conditions_met = []
      for (let i = 0; i < this.interview.conditions_to_check.split('|').length; i++) {
        this.conditions_met[i] = false
      }
      try {
        gtag('event', `edit_details${this.old ? '_alt' : ''}`);
      } catch (error) {
        console.log(error)
      }
    },
    scrollDown() {
      this.$vuetify.goTo(9999)
      try {
        gtag('event', `press_scroll_down${this.old ? '_alt' : ''}`);
      } catch (error) {
        console.log(error)
      }
    },
    started_answer() {
      try {
        if(!this.start_answer) {
          gtag('event', `started_answer${this.old ? '_alt' : ''}`);
          try {
            gtag('event', `${this.lead.country_name.en}_${this.lead.program_name.en}_${this.date}_started_answer${this.old ? '_alt' : ''}`);
          } catch (error) {
            console.log(error)
          }
          this.start_answer = true
        }
      } catch (error) {
        console.log(error)
      }
    },
    openLink(path){
      try {
        gtag('event', `open_link${this.old ? '_alt' : ''}`);
      } catch (error) {
        console.log(error)
      }
      window.open(path, '_blank').focus();
    },
    async updateScore(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let max = Object.keys(this.conditions_met).length
        let trues = Object.values(this.conditions_met).filter(x=>x).length
        let score = parseInt(trues / max * 100)
        console.log(this.conditions_met, max, trues, score)
        let en_id = this.$route.params.en_id
        let old = this.$route.query && this.$route.query.email ? true : false
        let hasher = old ? 'updateScorebyhashemail' : 'updateScorebyhash'
        let r  = await axios.post(`https://aramccoonline.com/back/public/api/v1/${hasher}/${en_id}`, {score}, {headers}).then(x=>x.data)
        this.$emit('snackbarNotification', `تم التحديث بنجاح`, 'success')
        try {
          gtag('event', `add_details${this.old ? '_alt' : ''}`);
          if(score < 100) {
            gtag('event', `failed_score${this.old ? '_alt' : ''}`);
            gtag('event', 'failed_score_' + score);
            try {
              gtag('event', `${this.lead.country_name.en}_${this.lead.program_name.en}_${this.date}_failed_${score}${this.old ? '_alt' : ''}`);
            } catch (error) {
              console.log(error)
            }
          }
        } catch (error) {
          console.log(error)
        }
        
        this.confirmDetails = true
        this.loading = false
      })
    },
    async confirmAppointment() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(this.selectedSeminar)
        let en_id = this.$route.params.en_id
        let booked_appointment = this.selectedSeminar
        let old = this.$route.query && this.$route.query.email ? true : false
        let hasher = 'confirmbyhashonline'
        let r  = await axios.post(`https://aramccoonline.com/back/public/api/v1/${hasher}/${en_id}`, {booked_appointment}, {headers}).then(x=>x.data)
        this.$emit('snackbarNotification', `تم تأكيد الحضور بنجاح`, 'success')
        this.invitation = false
        this.confirmation = false
        this.confirmedAppointment = true
        await this.getLead()
        try {
          gtag('event', `autoconfirm${this.old ? '_alt' : ''}`);
        } catch (error) {
          console.log(error)
        }
        try {
          gtag('event', `${this.lead.country_name.en}_${this.lead.program_name.en}_${this.date}_autoconfirm${this.old ? '_alt' : ''}`);
        } catch (error) {
          console.log(error)
        }
        this.loading = false
      })
    },
    getFormat(d){
      return format(d)
    },
    async saveEmail(){
      this.loading = true
      let p = {
        email:this.email
      }
      let en_id = this.$route.params.en_id
      let r  = await axios.post(`https://aramccoonline.com/back/public/api/v1/updatebyhash/${en_id}`, p, {headers}).then(x=>x.data)
      console.log(r)
      if(!r.error) {
        this.$emit('snackbarNotification', `تم التحديث بنجاح`, 'success')
      }
      this.loading = false
    },
    testEmail(){
      let a = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)
      console.log(a)
      return a
    },
    async getLead() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        let old = this.$route.query && this.$route.query.email ? true : false
        this.old = old
        let hasher = 'hashonlinelead'
        let en_id = this.$route.params.en_id
        let s = await axios.get(`https://aramccoonline.com/back/public/api/v1/${hasher}/${en_id}`).then(x=>x.data)
        console.log(s)
        if(!s.error) {
          this.lead = s.lead
          this.seminars = s.seminars
          this.candidate = s.candidate
          this.selectedSeminar = this.seminars[0].id
          if(s.lead && s.lead.booked_appointment) {
            this.invitation = false
            this.confirmation = false
            this.confirmedAppointment = true
            try {
              gtag('event', `reopen_confirmation${this.old ? '_alt' : ''}`);
            } catch (error) {
              console.log(error)
            }
          }
          this.conditions = s.seminars[0].conditions_array;
          if(s.lead && s.lead.email) {
            this.email = s.lead.email
          }
          try {
            gtag('event', `${this.lead.country_name.en}_${this.lead.program_name.en}_${this.date}_open${this.old ? '_alt' : ''}`);
          } catch (error) {
            console.log(error)
          }
        }
        this.loading = false
      })
    },
    async getRoute(){
      return new Promise(async (res, rej)=>{
        let a = this.$route.name
        if(a == 'ensa') {
          this.invitation = true
          this.confirmation = false
        } else if (a == 'OnlineInvitation') {
          this.invitation = false
          this.confirmation = true
        }
        res(a)
      })
    }
    
  },
  watch:{
  },
  computed:{
    
    checkIfFit() {
      let b = Object.values(this.conditions_met)
      let c = b.filter(x=> !x).length
      if(c > 0) {
        return false
      } else {
        return true
      }
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    goalModel(){
      return this.$store.state.goalModel
    },
    keyResultModel(){
      return this.$store.state.keyResultModel
    },
    initModel(){
      return this.$store.state.initiativeModel
    },
    units(){
      return this.$store.state.units
    },
    quarters(){
      return this.$store.state.quarters
    },
    fileTypes(){
      return this.$store.state.fileTypes
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    await this.getRoute()
    await this.getLead()
  },
  
}
</script>

<style>
.forceLTR * {
  direction:ltr !important;
  text-align: left !important;
}
.forceLTR label {
  right:unset!important;
}
</style>